var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockUnlocked05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.0002V8.00021C7 5.23879 7.73196 3.12911 10.5 3.00021M12 14.5002V16.5002M8.8 21.0002H15.2C16.8802 21.0002 17.7202 21.0002 18.362 20.6732C18.9265 20.3856 19.3854 19.9267 19.673 19.3622C20 18.7204 20 17.8804 20 16.2002V14.8002C20 13.1201 20 12.28 19.673 11.6382C19.3854 11.0738 18.9265 10.6148 18.362 10.3272C17.7202 10.0002 16.8802 10.0002 15.2 10.0002H8.8C7.11984 10.0002 6.27976 10.0002 5.63803 10.3272C5.07354 10.6148 4.6146 11.0738 4.32698 11.6382C4 12.28 4 13.1201 4 14.8002V16.2002C4 17.8804 4 18.7204 4.32698 19.3622C4.6146 19.9267 5.07354 20.3856 5.63803 20.6732C6.27976 21.0002 7.11984 21.0002 8.8 21.0002Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnlocked05);
export default __webpack_public_path__ + "static/media/lock-unlocked-05.eba372bb98ca784a80005bec2c497da0.svg";
export { ForwardRef as ReactComponent };